import { useState } from "react";
import { Link } from "react-router-dom";
import api, { formatError } from "@/api/client";
import { BookOpen } from "lucide-react";

export default function ForgotPasswordPage() {
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const [error, setError] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    try {
      await api.post("/auth/forgot-password", { email });
      setSent(true);
    } catch (err) {
      setError(formatError(err));
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-zinc-50 p-4">
      <div className="w-full max-w-md">
        <Link to="/login" className="flex items-center gap-2 mb-8">
          <div className="w-10 h-10 bg-[#41B5E6] flex items-center justify-center rounded-sm">
            <BookOpen className="w-5 h-5 text-white" />
          </div>
          <div className="font-black text-lg tracking-tight">Handle Docs</div>
        </Link>
        <div className="bg-white border border-zinc-200 p-8 rounded-sm">
          {sent ? (
            <div data-testid="forgot-sent">
              <h1 className="text-2xl font-bold mb-2">Check your email</h1>
              <p className="text-sm text-zinc-600">If an account exists for <strong>{email}</strong>, a reset link has been sent.</p>
              <Link to="/login" className="text-sm text-[#41B5E6] hover:underline mt-4 inline-block">Back to login</Link>
            </div>
          ) : (
            <>
              <h1 className="text-2xl font-bold mb-1">Forgot password?</h1>
              <p className="text-sm text-zinc-500 mb-6">We'll send you a reset link.</p>
              <form onSubmit={submit} className="space-y-4">
                <input type="email" required value={email} onChange={(e) => setEmail(e.target.value)} placeholder="Email"
                  data-testid="forgot-email"
                  className="w-full px-3 py-2.5 border border-zinc-300 rounded-sm text-sm focus:outline-none focus:ring-2 focus:ring-[#41B5E6]" />
                {error && <div className="text-sm text-rose-600">{error}</div>}
                <button data-testid="forgot-submit" className="w-full bg-[#41B5E6] hover:bg-[#2A9BCC] text-white font-semibold py-2.5 rounded-sm">Send reset link</button>
              </form>
            </>
          )}
        </div>
      </div>
    </div>
  );
}
